import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, Loader2, Trash2, Receipt } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Skeleton } from "@/components/ui/skeleton";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";

const fmt = (n) => new Intl.NumberFormat("tr-TR").format(n);

export default function Expenses() {
  const [items, setItems] = useState(null);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ category: "", amount: "", note: "" });
  const [saving, setSaving] = useState(false);

  const load = () => api.get("/expenses").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const save = async () => {
    setSaving(true);
    try { await api.post("/expenses", { category: form.category, amount: Number(form.amount), note: form.note }); toast.success("Gider eklendi"); setOpen(false); setForm({ category: "", amount: "", note: "" }); load(); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setSaving(false); }
  };
  const del = async (id) => { try { await api.delete(`/expenses/${id}`); toast.success("Gider silindi"); load(); } catch (e) { toast.error("Silinemedi"); } };

  const total = (items || []).reduce((a, e) => a + e.amount, 0);

  return (
    <div data-testid="admin-expenses-page">
      <PageHeader title="Giderler" subtitle={`Toplam: ₺${fmt(total)}`}
        action={<Button onClick={() => setOpen(true)} data-testid="add-expense-button" className="bg-[#FF5500] hover:bg-[#FF661A] text-white font-bold rounded-xl"><Plus size={18} className="mr-1" /> Gider Ekle</Button>} />
      {items === null ? <div className="space-y-2">{[...Array(4)].map((_, i) => <Skeleton key={i} className="h-14 rounded-xl bg-[#13131C]" />)}</div> : items.length === 0 ? <div className="text-center py-20 text-[#68687B]">Gider kaydı yok.</div> : (
        <div className="space-y-2">
          {items.map((e) => (
            <div key={e.id} data-testid={`expense-${e.id}`} className="flex items-center gap-3 p-4 rounded-2xl bg-[#13131C] border border-[#222230]">
              <div className="w-10 h-10 rounded-xl bg-[#EF4444]/10 flex items-center justify-center"><Receipt size={18} className="text-[#EF4444]" /></div>
              <div className="flex-1"><p className="font-semibold text-white">{e.category}</p><p className="text-xs text-[#68687B]">{e.date}{e.note ? ` · ${e.note}` : ""}</p></div>
              <span className="font-mono font-bold text-[#EF4444]">-₺{fmt(e.amount)}</span>
              <button onClick={() => del(e.id)} data-testid={`delete-expense-${e.id}`} className="p-2 rounded-lg text-[#68687B] hover:text-[#EF4444] hover:bg-[#252536]"><Trash2 size={16} /></button>
            </div>
          ))}
        </div>
      )}
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-[#13131C] border-[#222230] text-white max-w-sm">
          <DialogHeader><DialogTitle className="font-display text-xl">Yeni Gider</DialogTitle><DialogDescription className="text-[#68687B]">Kira, personel, ekipman vb.</DialogDescription></DialogHeader>
          <div className="space-y-3 py-1">
            <div><label className="text-xs text-[#A0A0B2] mb-1 block">Kategori</label><Input value={form.category} onChange={(e) => setForm({ ...form, category: e.target.value })} data-testid="expense-category" className="bg-[#0E0E14] border-[#262636] text-white" /></div>
            <div><label className="text-xs text-[#A0A0B2] mb-1 block">Tutar ₺</label><Input type="number" value={form.amount} onChange={(e) => setForm({ ...form, amount: e.target.value })} data-testid="expense-amount" className="bg-[#0E0E14] border-[#262636] text-white" /></div>
            <div><label className="text-xs text-[#A0A0B2] mb-1 block">Not</label><Input value={form.note} onChange={(e) => setForm({ ...form, note: e.target.value })} className="bg-[#0E0E14] border-[#262636] text-white" /></div>
          </div>
          <DialogFooter>
            <Button variant="ghost" onClick={() => setOpen(false)} className="text-[#A0A0B2]">İptal</Button>
            <Button onClick={save} disabled={saving || !form.category || !form.amount} data-testid="expense-submit" className="bg-[#FF5500] hover:bg-[#FF661A] text-white font-bold">{saving ? <Loader2 className="animate-spin" size={16} /> : "Kaydet"}</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
